import React from "react";
import "./Chelia.scss";
import Produk1 from "./Chelia/Chelia1.jsx";
import logoviola from "../../media/logo/chelia.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SoultanLimages from "./CheliaL.js";
import SoultanFimages from "./CheliaF.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const rumah = () => {
  const settings1 = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settings2 = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const items = [
    "Private Clubhouse",
    "Swimming Pool",
    "Children Playground",
    "Jogging Track",
    "Green Park  ",
    "Lake View",
    "One System Gate",
    "Security 24 Hours",
  ];
  return (
    <div id="viola" className="Chelia">
      <div className="logo-viola">
        <img src={logoviola} alt="logo-viola" />
      </div>
      <div className="heroviola">
        <div className="slider-viola">
          <Slider {...settings1}>
            {SoultanLimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
        </div>
        <div className="desk-viola">
          <div className="highlight">
            Hunian modern, strategis, dan lengkap—cukup dengan cicilan mulai 4
            jutaan per bulan!
          </div>
          Cluster Chelia – Hunian ideal untuk rumah pertama kamu, hanya mulai
          dari 900 jutaan di kawasan premium milik developer terpercaya
          Summarecon. Dirancang dengan konsep rumah compact yang efisien, hunian
          ini menghadirkan open space layout serta attic floor serbaguna.
          Nikmati pemandangan danau serta kelengkapan fasilitas eksklusif
          seperti private Clubhouse, Swimming Pool, lounge, dan Children
          Playground. Lokasi super strategis yang mendukung aktivitas harian,
          Keunggulan Lokasi :
          <div className="container-benefit">
            <div className="benefit-list">
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;Jalan kaki ke fasilitas pendidikan
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;2 menit ke fasilitas rumah sakit
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;2 menit ke Mall Summarecon Crown Gading (Mall
                  terbesar yang pernah dibangun oleh Summarecon)
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;2 menit ke Food Village
                </span>
              </div>

              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;5 menit ke pasar modern
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;5 menit ke akses transportasi umum
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faCheckDouble} color="#ffffffff" />
                <span style={{color: "rgba(255, 255, 255, 1)"}}>
                  &nbsp;&nbsp;7 menit ke pintu Tol Tarumajaya
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="Judul"></div>
        <div className="rumah-card">
          <Produk1 />
        </div>
      </div>
      <div className="fasilitas-viola">
        <div className="slider-fasilitas">
          <Slider {...settings2}>
            {SoultanFimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
        </div>
      </div>
      <ul className="fasilitas-list">
        {items.map((item, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={faCheckDouble} color="white" />
            <span> &nbsp; {item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default rumah;
